<template>
  <section>
    <div class="page_content">

      <!-- Banner -->
      <div class="banner">
        <div class="banner_title ">
          <div class="banner_title_text animation-fade-in">
            <h1>Prepaid Surprise</h1>
            <p>15 jaar Prepaid Surprise.<br>Vier je met ons mee?</p>
            <button type="button" @click="this.playGame" class="black_btn two">
              <div class="black_btn_contain"><p>Speel en win</p></div></button>
            <button type="button" @click="this.buyBundle" class="black_btn two_btns_home">
              <div class="black_btn_contain"><p>Koop een bundel</p></div></button>
          </div>
        </div>
      </div>
      <!-- Banner -->

      <div class="glow_bg" id="physicalPrizeCarousel">
        <div class="banners_container">
          <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank">
            <img src="static/img/millen_images/banner_1_desktop.png" alt="Desktop Banner" class="banner_responsive_image banner_desktop_image">
            <img src="static/img/millen_images/banner_1_mobile.png" alt="Mobile Banner" class="banner_responsive_image banner_mobile_image">
          </a>
        </div>
        <div class="monthly_prizes">
          <h1>Prijzen</h1>
          <h2>Hoofdprijzen {{ currentMonth }}</h2>
          <div class="container-fluid">
            <div class="row justify-content-center">
              <div v-for="(item, index) in physical" class="box">
                <div v-on:click="physicalPrize(index)">
                  <div class="d-flex flex-column">
                    <img :src="physical[index].image" alt="">
                    <div class="drop">
                      <p>{{ physical[index].quantity }}</p>
                    </div>
                    <div class="title">{{ physical[index].name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="t_prizes">
        <div class="container">
          <h1>Odido prijzen</h1>
          <h2>Wanneer je Prepaid Surprise speelt krijg je altijd de keuze uit gratis MB’s, belminuten of sms’jes. Als je opwaardeert met 20 euro of meer kun je ook kiezen voor 5 euro promo-tegoed. Bij ons is iedereen een winnaar!</h2>
        </div>
        <div class="container_prizes">
          <div class="row justify-content-center">
            <a @click.prevent="prizeData()" class="box">
              <div class="d-flex flex-column">
                <img src="static/img/millen_images/icons/telco_icon_net.png" alt="">
                <div class="title">300 MB</div>
              </div>
            </a>
            <a @click.prevent="prizeMinutes()" class="box">
              <div class="d-flex flex-column">
                <img src="static/img/millen_images/icons/telco_icon_time.png" alt="">
                <div class="title">10 Belminuten</div>
              </div>
            </a>
            <a @click.prevent="prizeSms()" class="box">
              <div class="d-flex flex-column">
                <img src="static/img/millen_images/icons/telco_icon_sms.png" alt="">
                <div class="title">30 Sms'jes</div>
              </div>
            </a>
            <a @click="prizeEuro()" class="box">
              <div class="d-flex flex-column">
                <img src="static/img/millen_images/icons/telco_icon_promo.png" alt="">
                <div class="title">€5 Promo-tegoed</div>
              </div>
            </a>
          </div>
        </div>
        <button type="button" @click="goToWinners" class="black_secondary_btn">Bekijk eerdere winnaars
        </button>
      </div>
    </div>
    <div class="win_steps">
      <div class="container container_steps">
        <div class="row justify-content-center">
          <h1>Win in 3 stappen</h1>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-4 col-12 text-center step_box">
            <div class="gradient_circle"><p>1</p></div>
            <div class="title">Nieuw beltegoed</div>
            <div class="desc">Waardeer op vanaf € 10 of koop via iDEAL een bundel vanaf € 7,50. Dan krijg je een gratis speelcode.</div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 text-center step_box">
            <div class="gradient_circle"><p>2</p></div>
            <div class="title">Spelen</div>
            <div class="desc">Klik op je unieke code in de sms en speel het spel.</div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 text-center step_box">
            <div class="gradient_circle"><p>3</p></div>
            <div class="title">Winnen</div>
            <div class="desc">Je ziet meteen wat je hebt gewonnen.
            </div>
          </div>
        </div>

        <div class="row justify-content-center how_btns btn_content">
          <button type="button" class="blue_btn" @click="this.playGame">Speel nu mee</button>
          <button type="button" class="black_secondary_btn" @click="this.topUpNow">Nu opwaarderen</button>
          <div class="actlink"> <a href="https://www.odido.nl/mobiel/prepaid/bundels" target="blank">    <button type="button" class="black_secondary_btn">Koop een bundel</button></a></div>

        </div>


      </div>
    </div>

    <div v-if="!hasAccessToken()" class="login_section" id="login_section" ref="login">
      <div class="container">
        <div class="row justify-content-center">
          <h1>Inloggen</h1>
        </div>
        <div class="row justify-content-center input_block">
          <form>
            <div :class="{'form-group': true, 'error': !isValidMsisdn}">
              <input v-model="msisdn" type="tel" class="form-control" id="mobile" name="mobile"
                     placeholder="Je mobiele nummer"
                     required/>

              <div v-if="!isValidMsisdn" class="error_msg">
                <p class="form_title_input">Je mobiele nummer</p>
                Ongeldig mobiele nummer. Je mobiele nummer moet beginnen met 06 en bestaat uit 10
                cijfers. Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
            </div>

            <div :class="{'form-group': true, 'error': !isValidPassword}">
              <input v-model="password" type="password" class="form-control" id="pass" name="pass"
                     placeholder="Je wachtwoord"
                     required/>

              <div v-if="!isValidPassword" class="error_msg">
                <p class="form_title_input">Je wachtwoord</p>
                Oeps, er ging iets fout. Probeer het later nog eens.
              </div>
            </div>

            <button type="button" class="black_btn login_btn_home disa"><div class="black_btn_contain" @click.prevent="loginUser">Inloggen</div></button>
          </form>
        </div>
        <div class="row justify-content-between login_links">
          <div v-if="isOptedOut" class="error_msg">
            Je bent momenteel afgemeld voor Prepaid Surprise. Als je doorgaat word je automatisch
            weer aangemeld en ontvang je vanaf nu weer berichten en speelcodes van Prepaid Surprise.
          </div>
          <div v-if="!isCorrectPassword" class="error_msg">
            Je gebruikersnaam (mobiele nummer) en wachtwoord komen niet overeen. Probeer het nog
            eens.
          </div>
          <div v-if="internalError" class="error_msg">
            Oeps, er ging iets fout. Probeer het later nog eens.
          </div>
          <a v-on:click.prevent="goToForgotPassword()" href="">Wachtwoord vergeten? </a>
          <a v-on:click.prevent="goToRegister()" href="">Meld je aan</a>
        </div>
      </div>
    </div>

    <div class="cards_section">
      <div class="container">
        <div class="row justify-content-center">
          <h1>Doe mee en win</h1>
        </div>
        <div class="row justify-content-center">
          <div class="card forthree">
            <img src="static/img/millen_images/left_image_cards.png" alt="">
            <div class="d-flex flex-column text-center card_content">
              <div class="card_text">
                Wil je een nieuwe speelcode, waardeer dan nu op.
              </div>
              <span class="arrow_blue"> <a href="https://opwaarderen.odido.nl" target="_blank">Nu opwaarderen</a></span>
            </div>
          </div>
          <div class="card forthree">
            <img src="static/img/millen_images/bundles_image_cards.png">
            <div class="d-flex flex-column text-center card_content">
              <div class="card_text">
                Een nieuwe speelcode? Koop via iDEAL een bundel vanaf € 7,50.
              </div>
              <span class="arrow_blue"> <a href="https://www.odido.nl/mobiel/prepaid/bundels" target="blank">Koop een bundel</a></span>
            </div>
          </div>
          <div class="card second forthree">
            <img src="static/img/millen_images/right_image_cards.png">
            <div class="d-flex flex-column text-center card_content">
              <div class="card_text">
                Nog geen Odido klant? Bestel hier je Prepaid simkaart.
              </div>
              <span class="arrow_blue">
                <a href="https://odido.nl/mobiel/prepaid" target="_blank">Prepaid simkaart</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <play-and-win v-if="playGameModal"></play-and-win>
    <accept-terms v-if="acceptTermsModal"></accept-terms>
    <lost-code v-if="lostCodeModal"></lost-code>
    <popup-physical-prize v-if="physicalPrizeModal"></popup-physical-prize>
    <popup-prize-data v-if="prizeDataModal"></popup-prize-data>
    <popup-prize-sms v-if="prizeSmsModal"></popup-prize-sms>
    <popup-prize-euro v-if="prizeEuroModal"></popup-prize-euro>
    <popup-prize-minutes v-if="prizeMinutesModal"></popup-prize-minutes>
  </section>
</template>

<script>
import PhysicalPrize from './modals/PhysicalPrize'
import PrizeMinutes from './modals/PrizeMinutes'
import PrizeData from './modals/PrizeData'
import PrizeSms from './modals/PrizeSms'
import PrizeEuro from './modals/PrizeEuro'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import PlayAndWin from './modals/PlayAndWin'
import AcceptTermsPopUp from './modals/AcceptTermsPopUp'
import LostCode from './modals/LostCode'
import router from '../router'
import gameFlow from '../common/mixin/gameFlow'
import gtm_analytics from "../common/mixin/gtm_analytics";

export default {
  name: 'Home',
  components: {
    'play-and-win': PlayAndWin,
    'accept-terms': AcceptTermsPopUp,
    'lost-code': LostCode,
    'popup-physical-prize': PhysicalPrize,
    'popup-prize-data': PrizeData,
    'popup-prize-sms': PrizeSms,
    'popup-prize-euro': PrizeEuro,
    'popup-prize-minutes': PrizeMinutes
  },
  mixins: [
    gameFlow,
    gtm_analytics
  ],
  data() {
    return {
      msisdn: null,
      password: null,
      isValidMsisdn: true,
      isValidPassword: true,
      isCorrectPassword: true,
      isOptedOut: false,
      loginAsOptOutAttempt: 0,
      internalError: false,
      physical: [],
      currentMonth: new Date().toLocaleString('nl-NL', {month: 'long'}),
      confettiInterval: null
    }
  },
  computed: {
    ...mapGetters([
      'isPlayGameModalOpen',
      'isAcceptTermsModalOpen',
      'isLostCodeModalOpen',
      'getLoginResponse',
      'getAccessToken',
      'isLostCodeModalOpen',
      'isPhysicalPrizeModalOpen',
      'isPrizeDataModalOpen',
      'isPrizeSmsModalOpen',
      'isPrizeEuroModalOpen',
      'isPrizeMinutesModalOpen',
      'physicalPrizeResponse',
      'getCompareCustomerPasswordResponse',
      'getOptInResponse'
    ]),
    playGameModal() {
      return this.isPlayGameModalOpen
    },
    acceptTermsModal() {
      return this.isAcceptTermsModalOpen
    },
    lostCodeModal() {
      return this.isLostCodeModalOpen
    },
    physicalPrizeModal() {
      return this.isPhysicalPrizeModalOpen
    },
    prizeDataModal() {
      return this.isPrizeDataModalOpen
    },
    prizeSmsModal() {
      return this.isPrizeSmsModalOpen
    },
    prizeEuroModal() {
      return this.isPrizeEuroModalOpen
    },
    prizeMinutesModal() {
      return this.isPrizeMinutesModalOpen
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.getPhysicalPrize()
      .then((response) => {
        this.$store.commit('updatePhysicalPrizeResponse', response.data.customRewardInfoApiPhysicalList)
        this.physical = this.physicalPrizeResponse
      })

    let param = this.$route.path.substring(3)
    if (param !== "") {
      this.shortUrlCode(param)
        .then(response => {
          if (response.status === 200) {
            this.$store.commit('updateRedemptionMsisdn', response.data.shortenedUrlInfo.msisdn)
            this.$store.commit('updateSelectedCodeForRedemption', response.data.shortenedUrlInfo.code)

            this.loadConversation()
              .then((conversationResponse) => {
                this.$store.commit('updateGameFlowState', response.data.currentConversationState)
                this.loadInfoFromConversation(conversationResponse)
                this.gameRouting()
              })

          }
        })
    }
    this.setInGameFlow("false", this.$route.params)
    this.triggerConfetti()
  },
  beforeDestroy() {
    if (this.confettiInterval) {
      clearInterval(this.confettiInterval)
      this.confettiInterval = null
    }
  },
  methods: {
    ...mapMutations([
      'updatePlayGameModal',
      'updateAcceptTermsModal',
      'updateLostCodeModal',
      'updateMsisdn',
      'updateRedemptionMsisdn',
      'updatePassword',
      'updateAccessToken',
      'updateLostCodeModal',
      'updatePhysicalPrizeModal',
      'updatePrizeDataModal',
      'updatePrizeSmsModal',
      'updatePrizeEuroModal',
      'updatePrizeMinutesModal',
      'updatePhysicalPrizeResponse',
      'updateModalPhysicalPrizeId',
      'updateRegisterModal',
      'updateForgotPasswordModal'
    ]),
    ...mapActions([
      'getPhysicalPrize',
      'accountLogin',
      'shortUrlCode',
      'loadConversation',
      'accountLogin',
      'compareCustomerPassword',
      'optInCustomer'
    ]),

    hasAccessToken() {
      return (this.getAccessToken) ? true : false
    },

    resetValidityFlags() {
      this.isValidMsisdn = true
      this.isValidPassword = true
      this.isCorrectPassword = true
      this.isOptedOut = false
      this.internalError = false
    },

    msisdnValidation() {
      return (/^(06[0-9]{8}|097[0-9]{9})$/.test(this.msisdn))
    },

    passwordValidation() {
      return (/^.{8,}$/.test(this.password))
    },

    validateForm() {
      if(!this.msisdnValidation() && !this.passwordValidation()) {
        this.isValidMsisdn = false
        this.isValidPassword = false
        return false
      }
      else if (!this.msisdnValidation()) {
        this.isValidMsisdn = false
        return false
      } else {
        if (!this.passwordValidation()) {
          this.isValidPassword = false
          return false
        }
      }
      return true
    },

    loginUser() {
      this.updateMsisdn(this.msisdn)
      this.updateRedemptionMsisdn(this.msisdn)
      this.updatePassword(this.password)
      this.resetValidityFlags()

      if (this.validateForm()) {
        this.compareCustomerPassword({
          msisdn: this.msisdn,
          password: this.password
        })
          .then(() => {
            if (this.getCompareCustomerPasswordResponse === null) {
              this.internalError = true
            } else {
              if (this.getCompareCustomerPasswordResponse.failReason === "NOT_EXISTS")
                this.isValidMsisdn = false

              if (this.getCompareCustomerPasswordResponse.failReason === "WRONG_PASSWORD")
                this.isCorrectPassword = false

              if (this.getCompareCustomerPasswordResponse.result === "SUCCESS") {
                if (this.loginAsOptOutAttempt === 1) {
                  this.handleLoginAsOptout()
                } else {
                  this.submitLogin()
                }

              }
            }
          })
      }
    },

    handleLoginAsOptout() {
      this.optInCustomer({msisdn: this.msisdn})
        .then(() => {
          if (this.getOptInResponse === null) {
            this.internalError = true
          } else {
            this.submitLogin()
          }
        })
    },

    submitLogin() {
      this.accountLogin()
        .then(() => {

          if (this.getLoginResponse === null) {
            this.internalError = true
          } else {
            if (this.getLoginResponse.isUserLoggedIn === true) {
              this.updateAccessToken(this.getLoginResponse.encryptedKey)
              router.push({name: 'Account'})
            } else {
              this.handleLoginResult()
            }
          }
        })
    },

    handleLoginResult() {
      if (this.getLoginResponse.failReason === 'OPTED_OUT') {
        this.isOptedOut = true
        this.loginAsOptOutAttempt = this.loginAsOptOutAttempt === 0 ? 1 : 0
      }
    },

    playGame() {
      this.updatePlayGameModal(true)
    },
    topUpNow() {
      window.open('https://opwaarderen.odido.nl', '_blank')
    },
    buyBundle() {
      window.open('https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels', '_blank')
    },
    physicalPrize(index) {
      this.updatePhysicalPrizeModal(true)
      this.updateModalPhysicalPrizeId(index)
    },
    prizeMinutes() {
      this.updatePrizeMinutesModal(true)
    },
    prizeData() {
      this.updatePrizeDataModal(true)
    },
    prizeSms() {
      this.updatePrizeSmsModal(true)
    },
    prizeEuro() {
      this.updatePrizeEuroModal(true)
    },
    goToRegister() {
      this.updateRegisterModal(true)
    },
    goToForgotPassword() {
      this.updateForgotPasswordModal(true)
    },
    goToWinners() {
      router.push({name: 'Winners'})
    },
    triggerConfetti() {
      if (typeof window.confetti !== 'function') {
        return
      }
      const duration = 5 * 1000
      const animationEnd = Date.now() + duration
      const defaults = {
        zIndex: 1039,
        colors: ["#7066ff", "#ff7621", "#2f9a92"],
        shapes: ["circle"]
      }

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min
      }

      this.confettiInterval = setInterval(() => {
        const timeLeft = animationEnd - Date.now()

        if (timeLeft <= 0) {
          clearInterval(this.confettiInterval)
          this.confettiInterval = null
          return
        }

        const particleCount = 50 * (timeLeft / duration)
        window.confetti(Object.assign({}, defaults, {
          particleCount,
          origin: {x: randomInRange(0.1, 0.3), y: Math.random() - 0.2}
        }))
        window.confetti(Object.assign({}, defaults, {
          particleCount,
          origin: {x: randomInRange(0.7, 0.9), y: Math.random() - 0.2}
        }))
      }, 250)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue